export const FALLBACK_PRODUCT_NAME = 'Atlassian application';
export const getCompatibleProductName = compatibleProducts => {
  if (compatibleProducts.length === 1) {
    var _compatibleProducts$, _compatibleProducts$2;

    return (_compatibleProducts$ = (_compatibleProducts$2 = compatibleProducts[0].atlassianProduct) === null || _compatibleProducts$2 === void 0 ? void 0 : _compatibleProducts$2.name) !== null && _compatibleProducts$ !== void 0 ? _compatibleProducts$ : FALLBACK_PRODUCT_NAME;
  }

  return FALLBACK_PRODUCT_NAME;
};
export const isAppOnlyCompatibleWithProduct = (compatibleProducts, product) => compatibleProducts.length === 1 && compatibleProducts[0].id === product;